import { Form } from 'antd'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { apiUpdateOutlet } from '../../api'
import { OUTLET, DETAIL } from '../../assets/constants/route_path'
import ButtonBack from '../../components/button/ButtonBack'
import OutletForm from '../../components/outlet/OutletForm'
import { useLoading } from '../../context/LoadingContext'
import { IOutlet } from '../../models/outlet.modal'
import { toastError, toastSuccess } from '../../utils/toast'

export default function OutletUpdate() {
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const outlet = location.state as IOutlet | undefined
    const { setIsLoading } = useLoading()

    useEffect(() => {
        if (!outlet || !outlet.id) {
            navigate(OUTLET)
        }
    }, [outlet, navigate])

    if (!outlet || !outlet.id) return null

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading(true)
            const resp: any = await apiUpdateOutlet({ id: outlet.id, ...values })
            if (resp.status === 200) {
                toastSuccess('Cập nhật đại lý thành công!')
                navigate(OUTLET + DETAIL + `?id=${outlet.id}`)
                return
            }
            toastError('Có lỗi xảy ra!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            <ButtonBack />
            <h2>Cập nhật đại lý: {outlet.name}</h2>
            <OutletForm form={form} initial={outlet} onSubmit={handleSubmit} submitLabel='Cập nhật' onCancel={() => navigate(-1)} />
        </div>
    )
}
